import { z } from 'zod/v4';

export type OfferImportContextOrigin = z.infer<typeof OfferImportContextOriginRuntype>;
export const OfferImportContextOriginRuntype = z.enum(['CsvIntegration', 'ApiIntegration', 'ManualFileUpload']);

export type OfferImportContextDTO = z.infer<typeof OfferImportContextDTORuntype>;
export const OfferImportContextDTORuntype = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    origin: OfferImportContextOriginRuntype,
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

export type OfferImportContextCreationDTO = z.infer<typeof OfferImportContextCreationDTORuntype>;
export const OfferImportContextCreationDTORuntype = z.object({
    name: z.string(),
    description: z.string().nullable().optional(),
    origin: OfferImportContextOriginRuntype,
});

export type OfferImportContextUpdateDTO = z.infer<typeof OfferImportContextUpdateDTORuntype>;
export const OfferImportContextUpdateDTORuntype = z.object({
    name: z.string().optional(),
    // Tri-state: absent leaves the description unchanged, null clears it, a value sets it.
    description: z.string().nullable().optional(),
});
